import TilePageLayout from "../../layout/TilePageLayout";
import { useState } from "react";
import SettingsModal from "../../settings/SettingsModal";
import { useDockNavigation } from "../../layout/DockNavigationContext";
import { useAuth } from "../../../auth/useAuth";
import { getTileDesign } from "../tileDesign";

function getWorkspaceName(user) {
  return (
    user?.churchOrgSession?.account?.name ||
    user?.account?.name ||
    user?.organization?.name ||
    ""
  );
}

export default function TilePageTemplate({
  tileId,
  title,
  PageComponent,
  SettingsComponent,
  InfoComponent,
  onUninstall,
  showUninstall,
  showHeader = true,
}) {
  const [openSettings, setOpenSettings] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const { openTile } = useDockNavigation();
  const { user } = useAuth();
  const tileDesign = getTileDesign(tileId);
  const IconComponent = tileDesign.icon;
  const workspaceName = getWorkspaceName(user);

  return (
    <>
      <TilePageLayout
        title={title}
        subtitle={workspaceName}
        IconComponent={IconComponent}
        onSettings={() => setOpenSettings(true)}
        onInfo={() => setOpenInfo(true)}
        onUninstall={onUninstall}
        onClose={() => openTile("home")}
        showUninstall={showUninstall}
        showHeader={showHeader}
      >
        <PageComponent />
      </TilePageLayout>

      {openSettings && SettingsComponent && (
        <SettingsModal
          open={openSettings}
          onClose={() => setOpenSettings(false)}
        >
          <SettingsComponent tileId={tileId} />
        </SettingsModal>
      )}

      {openInfo && InfoComponent && (
        <SettingsModal
          open={openInfo}
          onClose={() => setOpenInfo(false)}
        >
          <InfoComponent tileId={tileId} />
        </SettingsModal>
      )}
    </>
  );
}
